import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactFormTexts } from './contact-form.type';
import { CloudPayService } from '../cloud-pay.service';
import { ContactSubmissionOptions } from '../types/cloud-pay-api.type';
import { BaseComponentDirective } from '@streamamg/amg-common';


@Component({
  selector: 'amg-contact-form',
  templateUrl: './contact-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host{display: block}'],
})
export class ContactFormComponent extends BaseComponentDirective implements OnInit {
  public isLoading: boolean;
  public submitSuccess: boolean;
  protected defaultTexts: ContactFormTexts;
  @Input() texts: ContactFormTexts;
  public serverErrors: string[];

  public form: FormGroup = new FormGroup({
    emailaddress: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
    body: new FormControl('', [
      Validators.required,
    ]),
    subject: new FormControl('', [
      Validators.maxLength(200),
    ]),
    name: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ]),
  });

  constructor(
      protected cloudPayService: CloudPayService,
      protected cd: ChangeDetectorRef,
  ) {
    super();
    this.submitSuccess = false;
    this.isLoading = false;

    this.defaultTexts = {
      fields: {
        emailaddress: {
          label: 'Email',
          placeholder: 'Type your Email',
          error_required: 'An Email is required',
          error_invalid_email: 'The Email is not valid',
        },
        body: {
          label: 'Message',
          placeholder: 'Type your Message here',
          error_required: 'A Message is required',
        },
        subject: {
          label: 'Subject',
          placeholder: 'Type topic of message',
          error_max_length: 'The Text is too long',
        },
        name: {
          label: 'Full name',
          placeholder: 'Type your Name',
          error_required: 'The Name is required',
          error_max_length: 'The Name is too long',
        },
      },
      title: 'Contact us',
      submit: 'Submit',
      message_fail_text: 'An error has occurred, please try later',
      message_sent_text: 'Message Submitted Successfully!',
      new_message: 'Submit New Message',
    };
  }

  ngOnInit(): void {

    this.texts = {...this.defaultTexts, ...this.texts};

  }

  public resetForm(): void {
    this.form.reset();
  }


  public isFieldInvalid(field: string): boolean {
    return (!this.form.get(field).valid && this.form.get(field).touched) || this.form.get(field).getError('server');
  }

  public formSubmit(): void {

    if (this.form.dirty && this.form.valid) {
      this.isLoading = true;
      this.cd.markForCheck();
      this.subSink = this.cloudPayService.submitContactForm(this.form.getRawValue() as ContactSubmissionOptions)
          .subscribe(res => {
            this.serverErrors = [];


            const errorKeys = !!res.ModelErrors ? Object.keys(res.ModelErrors) : null;

            if (errorKeys?.length > 0) {
              errorKeys.forEach(field => {

                if (this.form.get(field)) {

                  this.form.get(field).setErrors({server: res.ModelErrors[field]});

                } else {

                  this.serverErrors.push(res.ModelErrors[field]);
                }
              });
            } else {
              this.submitSuccess = true;
            }

            this.isLoading = false;
            this.cd.markForCheck();
          }, error => {
            this.serverErrors = [this.texts.message_fail_text];
            this.submitSuccess = false;

            this.isLoading = false;
            this.cd.markForCheck();
          });

    } else {

      this.validateAllFormFields();
    }
  }

  protected validateAllFormFields(): void {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields();
      }
    });
  }


  public submitNewMessage(): void {
    this.submitSuccess = false;
    this.resetForm();
    this.cd.detectChanges();
  }
}
